import { Pipe, PipeTransform } from '@angular/core';
import { Badge } from '../../../model/badge.model';
import { IconColorType } from '@app/tw-shared/components/icon/types/icon';

type AchievementType = Badge['type'];

const icons: Record<AchievementType, IconColorType> = {
    badge: 'colors',
    milestone: 'normal',
    activity: 'normal',
};

@Pipe({
    name: 'achievementIconType',
    standalone: false
})
export class AchievementIconTypePipe implements PipeTransform {
    transform(type: 'badge' | 'milestone' | 'activity') {
        return icons[type];
    }
}
